import { GameProviderSlug } from '@game/types'
import { PROVIDER_MAGNET, PROVIDER_EVOLUTION, PROVIDER_PARIPLAY, PROVIDER_GAMES_GLOBAL, PROVIDER_PRAGMATIC } from '@playgame/constants'

const PROVIDER_IDS: Partial<Record<string, number>> = {
    'magnet': PROVIDER_MAGNET,
    'evolution': PROVIDER_EVOLUTION,
    'pariplay': PROVIDER_PARIPLAY,
    'games-global': PROVIDER_GAMES_GLOBAL,
    'pragmatic-play': PROVIDER_PRAGMATIC,
}

const isMagnet = (provider: number | GameProviderSlug | undefined): boolean => provider === PROVIDER_MAGNET || String(provider)?.toLowerCase() === GameProviderSlug.MAGNET
const isEvolution = (provider: number | GameProviderSlug | undefined): boolean => provider === PROVIDER_EVOLUTION || String(provider)?.toLowerCase() === GameProviderSlug.EVOLUTION
const isPariplay = (provider: number | GameProviderSlug | undefined): boolean => provider === PROVIDER_PARIPLAY || String(provider)?.toLowerCase() === GameProviderSlug.PARIPLAY
const isGamesGlobal = (provider: number | GameProviderSlug | undefined): boolean => provider === PROVIDER_GAMES_GLOBAL || String(provider)?.toLowerCase() === GameProviderSlug.GAMES_GLOBAL
const isPragmatic = (provider: number | GameProviderSlug | undefined): boolean => provider === PROVIDER_PRAGMATIC || String(provider)?.toLowerCase() === GameProviderSlug.PRAGMATIC

const idFromSlug = (providerSlug: string): number | undefined => PROVIDER_IDS[providerSlug]

export default {
    isEvolution,
    isMagnet,
    isPariplay,
    isGamesGlobal,
    isPragmatic,
    idFromSlug,
}
